import {fabric} from 'fabric'
// import $ from "jquery"
import pavPng from '../images/car/pav.png'
import roll_d_Png from '../images/car/roll_d.png'
import roll_s_Png from '../images/car/roll_s.png'
import roll_t_Png from '../images/car/roll_l.png'
import { onePointerChange,setPathValue,timestampToTime } from './commons'
export default { 
    data() {
      return { 
        dataMap:'',
        dataMapTime: new Map(),
        dataMapPosi: new Map(),
        carMap: new Map(),
        carMapText: new Map(),
        car: '',
        setInter: '',
        rollNumColor: this.$store.state.rollNumColor,
        icvColor: this.$store.state.icvColor,
        nowTime: '',
        getCarList: [],
      };
    },
 
    methods: { 
        // 根据工况数据绘图
        drawByWork: function(canvas,midCanvas,sTime,data){
            this.dataMap = data.data.content.dataMap
            console.log(this.dataMap)
            console.log(this.dataMap['LT1712BJ0110'])
            for(var key in this.dataMap){
                // console.log("属性：" + key + ",值：" + this.dataMap[key]);
                this.dataMapTime[key] = this.getTimeInList(this.dataMap[key])
            }
            console.log(this.dataMapTime)
            if(this.workType == 4 || this.workType == 3){
                this.initCar(canvas,sTime)
            }else{
                this.initCarF(canvas,sTime)
            }
            
        },
        //绘制车辆初始位置
        initCar: function(canvas,e){
            let that = this
            let nowTime = new Date(e).getTime()
            let code = 15
            for(var key in this.dataMapTime){
                let posiCode = this.dataMapTime[key].indexOf(nowTime)
                if(posiCode >= 0){
                    let setData = this.dataMap[key][posiCode]
                    let pngSrc = ''
                    if(setData.equipType == 101){
                        pngSrc = pavPng
                    }else if(setData.equipType == 201){
                        pngSrc = roll_d_Png
                    }else if(setData.equipType == 202){
                        pngSrc = roll_s_Png
                    }else if(setData.equipType == 203){
                        pngSrc = roll_t_Png
                    }
                    
                    fabric.Image.fromURL(pngSrc,function(oImage){
                        that.carMap[setData.equipCode] = oImage.set({
                            left:setData.coordinateX*code+that.pyXCode,
                            top:setData.coordinateY*code*-1+that.pyYCode,
                            originX: 'center',
                            originY: 'center',
                            angle: setData.angle*1,
                            class:'group',
                            selectable: false,
                            hasBorders: false,
                            hasControls: false,
                            id: 'group',
                            carName: ''
                        }).scale(0.16)
                        canvas.add(that.carMap[setData.equipCode])
                    })
                    
                    let str1 = '名称:' + setData.equipName
                    let str2 = '编号:' + setData.equipCode
                    let eqCode1 = new fabric.Text(str1, {
                        fontSize: 12,
                        left: setData.coordinateX*code+that.pyXCode,
                        top: setData.coordinateY*code*-1+that.pyYCode-80,
                        originX: 'left',
                        originY: 'center',
                        id: 'groupText',
                        class:'groupText',
                        selectable: false,
                        hasBorders: false,
                        hasControls: false,
                    });
                    let eqCode2 = new fabric.Text(str2, {
                        fontSize: 12,
                        left: setData.coordinateX*code+that.pyXCode,
                        top: setData.coordinateY*code*-1+that.pyYCode-60,
                        originX: 'left',
                        originY: 'center',
                        id: 'groupText',
                        class:'groupText',
                        selectable: false,
                        hasBorders: false,
                        hasControls: false,
                    });
                    let groupList = [eqCode1,eqCode2]

                    that.carMapText[setData.equipCode] =  new fabric.Group(groupList,{
                        id: 'groupText',
                        class:'groupText',
                    })
                    canvas.add(that.carMapText[setData.equipCode])

                    this.dataMapPosi[setData.equipCode] = [setData.coordinateX*code+this.pyXCode,setData.coordinateY*code*-1+this.pyYCode]
                }
            }
            this.setInter = setInterval(()=>{
                nowTime = nowTime + 1000
                this.nowTime = nowTime
                this.nowDateTimeShow = timestampToTime(nowTime)
                this.playStart(nowTime,code,canvas)
            },1000)
        },

        initCarF: function(canvas,e){
            let that = this
            let nowTime = new Date(e).getTime()
            let canvasArr = canvas.getObjects();
            for (let i = 0; i < canvasArr.length; i++) {
                if (canvasArr[i].id == "group") {
                    canvas.remove(canvasArr[i]);
                }
            }
            this.getCarList = []
            for(let i=0;i<this.equipmnetList.length;i++){
                this.getCarList.push(this.equipmnetList[i].code)
            }
            for(var key in this.dataMapTime){
                let posiCode = this.dataMapTime[key].indexOf(nowTime)
                if(posiCode >= 0){
                    let setData = this.dataMap[key][posiCode]
                    if(this.getCarList.indexOf(setData.equipCode) >= 0){
                        let pngSrc = ''
                        if(setData.equipType == 101){
                            pngSrc = pavPng
                        }else if(setData.equipType == 201){
                            pngSrc = roll_d_Png
                        }else if(setData.equipType == 202){
                            pngSrc = roll_s_Png
                        }else if(setData.equipType == 203){
                            pngSrc = roll_t_Png
                        }
                        let getPosi = onePointerChange([setData.coordinateX,setData.coordinateY])
                        console.log(getPosi)
                        fabric.Image.fromURL(pngSrc,function(oImage){
                            that.carMap[setData.equipCode] = oImage.set({
                                left:getPosi[0],
                                top:getPosi[1],
                                originX: 'center',
                                originY: 'center',
                                angle: setData.angle*1,
                                class:'group',
                                selectable: false,
                                hasBorders: false,
                                hasControls: false,
                                id: 'group',
                                carName: ''
                            }).scale(0.16)
                            canvas.add(that.carMap[setData.equipCode])
                        })
                        
                        let str1 = '名称:' + setData.equipName
                        let str2 = '编号:' + setData.equipCode
                        let eqCode1 = new fabric.Text(str1, {
                            fontSize: 12,
                            left: getPosi[0],
                            top: getPosi[1]-80,
                            originX: 'left',
                            originY: 'center',
                            id: 'groupText',
                            class:'groupText',
                            selectable: false,
                            hasBorders: false,
                            hasControls: false,
                        });
                        let eqCode2 = new fabric.Text(str2, {
                            fontSize: 12,
                            left: getPosi[0],
                            top: getPosi[1]-60,
                            originX: 'left',
                            originY: 'center',
                            id: 'groupText',
                            class:'groupText',
                            selectable: false,
                            hasBorders: false,
                            hasControls: false,
                        });
                        let groupList = [eqCode1,eqCode2]

                        that.carMapText[setData.equipCode] =  new fabric.Group(groupList,{
                            id: 'groupText',
                            class:'groupText',
                        })
                        canvas.add(that.carMapText[setData.equipCode])

                        this.dataMapPosi[setData.equipCode] = [getPosi[0],getPosi[1]]
                    }
                    
                }
            }
            this.setInter = setInterval(()=>{
                nowTime = nowTime + 1000
                this.nowTime = nowTime
                this.nowDateTimeShow = timestampToTime(nowTime)
                this.playStartF(nowTime,canvas)
            },1000)
        },
        playStartF: function(e,canvas){
            this.percentNum = (e-this.startTime)*100/(this.endTime-this.startTime)
            let that = this
            let getTime = e
            console.log('play')
            console.log(this.dataMapTime)
            console.log(this.carMap)
            for(var key in this.dataMapTime){
                console.log(key)
                console.log(that.carMap[key])
                if(that.carMap[key]){
                    console.log('继续')

                    console.log('~~~~~~~~~~~~~~~')
                    let posiCode = this.dataMapTime[key].indexOf(getTime)
                    if(posiCode >= 0){
                        let setData = this.dataMap[key][posiCode]
                        let setDataL = this.dataMap[key][posiCode-1]
                        if(this.getCarList.indexOf(setData.equipCode) >= 0){
                            let getPosi = onePointerChange([setData.coordinateX,setData.coordinateY])
                            this.toPlay(this.carMap[setData.equipCode],getPosi[0],getPosi[1],setData.angle)
                            
                            
                            
                            // 文字更新
                            let canvasArr = canvas.getObjects();
                            for (let i = 0; i < canvasArr.length; i++) {
                                if (canvasArr[i].id == "groupText"+setData.equipCode || canvasArr[i].id == "groupText") {
                                    canvas.remove(canvasArr[i]);
                                }
                            }
                            let unit = setData.equipType == 101 ? 'm/min' : 'KM/H'
                            let str1 = '名称:' + setData.equipName
                            let str2 = '编号:' + setData.equipCode
                            let str3 = '速度:' + setData.speed + unit
                            let eqCode1 = new fabric.Text(str1, {
                                fontSize: 12,
                                left: getPosi[0],
                                top: getPosi[1]-80,
                                originX: 'left',
                                originY: 'center',
                                id: 'groupText'+setData.equipCode,
                                class:'groupText'+setData.equipCode,
                                selectable: false,
                                hasBorders: false,
                                hasControls: false,
                            });
                            let eqCode2 = new fabric.Text(str2, {
                                fontSize: 12,
                                left: getPosi[0],
                                top: getPosi[1]-60,
                                originX: 'left',
                                originY: 'center',
                                id: 'groupText'+setData.equipCode,
                                class:'groupText'+setData.equipCode,
                                selectable: false,
                                hasBorders: false,
                                hasControls: false,
                            });
                            let eqCode3 = new fabric.Text(str3, {
                                fontSize: 12,
                                left: getPosi[0],
                                top: getPosi[1]-40,
                                originX: 'left',
                                originY: 'center',
                                id: 'groupText'+setData.equipCode,
                                class:'groupText'+setData.equipCode,
                                selectable: false,
                                hasBorders: false,
                                hasControls: false,
                            });
                            // let groupList = [eqCode1,eqCode2,eqCode3]

                            // that.carMapText[setData.equipCode] =  new fabric.Group(groupList,{
                            //     id: 'groupText'+setData.equipCode,
                            //     class:'groupText'+setData.equipCode,
                            // })
                            canvas.add(eqCode1)
                            canvas.add(eqCode2)
                            canvas.add(eqCode3)
                            this.toPlay(eqCode1,getPosi[0],getPosi[1]-80,0.1)
                            this.toPlay(eqCode2,getPosi[0],getPosi[1]-60,0.1)
                            this.toPlay(eqCode3,getPosi[0],getPosi[1]-40,0.1)
                            
                            // console.log(that.carMapText[setData.equipCode])

                            
                            // if(setData.speed*1 <= 0){
                            //     return
                            // }
                            
                            // 填充颜色
                            let colorSet = ''
                            if(this.dimension == 1){
                                colorSet = '#32CD32'
                            }else if(this.dimension == 2){
                                colorSet = Math.ceil(this.dataMap[key][posiCode].rollingNum*1) < 20?this.rollNumColor[Math.ceil(this.dataMap[key][posiCode].rollingNum*1)]: this.rollNumColor[20]
                            }else if(this.dimension == 3){
                                if(this.dataMap[key][posiCode].icv < 64){
                                    colorSet = this.icvColor['64']
                                }else if(this.dataMap[key][posiCode].icv < 74){
                                    colorSet = this.icvColor['74']
                                }else if(this.dataMap[key][posiCode].icv < 84){
                                    colorSet = this.icvColor['84']
                                }else if(this.dataMap[key][posiCode].icv < 94){
                                    colorSet = this.icvColor['94']
                                }else{
                                    colorSet = this.icvColor['100']
                                }
                            }
                            // console.log(this.dataMap[key][posiCode].equipType)
                            if(this.dataMap[key][posiCode].equipType == 101){
                                colorSet = '#696969'
                            }
                            // if(setDataL.coordinateX == '0.0' || setDataL.coordinateY == '0.0'){
                            //     return
                            // }
                            // if(setData.coordinateX == '0.0' || setData.coordinateY == '0.0'){
                            //     return
                            // }
                            let getPosiNL = onePointerChange([setData.leftBoundaryMiddleCoordinateX,setData.leftBoundaryMiddleCoordinateY])
                            let getPosiNR = onePointerChange([setData.rightBoundaryMiddleCoordinateX,setData.rightBoundaryMiddleCoordinateY])
                            let getPosiLL = onePointerChange([setDataL.leftBoundaryMiddleCoordinateX,setDataL.leftBoundaryMiddleCoordinateY])
                            let getPosiLR = onePointerChange([setDataL.rightBoundaryMiddleCoordinateX,setDataL.rightBoundaryMiddleCoordinateY])
                            this.contextM.lineWidth = 1
                            this.contextM.beginPath();
                            this.contextM.strokeStyle  = colorSet;
                            this.contextM.moveTo(getPosiLL[0]*this.imgScale+this.imgX,getPosiLL[1]*this.imgScale+this.imgY)
                            this.contextM.lineTo(getPosiLR[0]*this.imgScale+this.imgX,getPosiLR[1]*this.imgScale+this.imgY)
                            this.contextM.lineTo(getPosiNR[0]*this.imgScale+this.imgX,getPosiNR[1]*this.imgScale+this.imgY)
                            this.contextM.lineTo(getPosiNL[0]*this.imgScale+this.imgX,getPosiNL[1]*this.imgScale+this.imgY)
                            // this.contextM.lineTo((setData.rightBoundaryMiddleCoordinateX*code+this.pyXCode)*this.imgScale + this.imgX,(setData.rightBoundaryMiddleCoordinateY*code*-1+this.pyYCode)*this.imgScale+this.imgY)
                            // this.contextM.lineTo((setData.leftBoundaryMiddleCoordinateX*code+this.pyXCode)*this.imgScale + this.imgX,(setData.leftBoundaryMiddleCoordinateY*code*-1+this.pyYCode)*this.imgScale+this.imgY)
                            // this.contextM.closePath();
                            this.contextM.fillStyle = colorSet;
                            this.contextM.fill();
                            this.contextM.stroke();
                        }
                        
                    }
                }else{
                    console.log('join')
                    let isCode = this.dataMapTime[key].indexOf(getTime)
                    if(isCode >= 0){
                        let setData = this.dataMap[key][isCode]
                        if(this.getCarList.indexOf(setData.equipCode) >= 0){
                            let pngSrc = ''
                            if(setData.equipType == 101){
                                pngSrc = pavPng
                            }else if(setData.equipType == 201){
                                pngSrc = roll_d_Png
                            }else if(setData.equipType == 202){
                                pngSrc = roll_s_Png
                            }else if(setData.equipType == 203){
                                pngSrc = roll_t_Png
                            }
                            let getPosi = onePointerChange([setData.coordinateX,setData.coordinateY])
                            fabric.Image.fromURL(pngSrc,function(oImage){
                                that.carMap[setData.equipCode] = oImage.set({
                                    left:getPosi[0],
                                    top:getPosi[1],
                                    originX: 'center',
                                    originY: 'center',
                                    angle: setData.angle*1,
                                    class:'group',
                                    selectable: false,
                                    hasBorders: false,
                                    hasControls: false,
                                    id: 'group',
                                    carName: ''
                                }).scale(0.16)
                                canvas.add(that.carMap[setData.equipCode])
                            })
                            let str1 = '名称:' + setData.equipName
                            let str2 = '编号:' + setData.equipCode
                            let eqCode1 = new fabric.Text(str1, {
                                fontSize: 12,
                                left: getPosi[0],
                                top: getPosi[1]-80,
                                originX: 'left',
                                originY: 'center',
                                id: 'groupText',
                                class:'groupText',
                                selectable: false,
                                hasBorders: false,
                                hasControls: false,
                            });
                            let eqCode2 = new fabric.Text(str2, {
                                fontSize: 12,
                                left: getPosi[0],
                                top: getPosi[1]-60,
                                originX: 'left',
                                originY: 'center',
                                id: 'groupText',
                                class:'groupText',
                                selectable: false,
                                hasBorders: false,
                                hasControls: false,
                            });
                            let groupList = [eqCode1,eqCode2]

                            that.carMapText[setData.equipCode] =  new fabric.Group(groupList,{
                                id: 'groupText',
                                class:'groupText',
                            })
                            canvas.add(that.carMapText[setData.equipCode])
                        }
                        
                    }
                    
                }
                
            }
        },

        playStart: function(e,code,canvas){
            this.percentNum = (e-this.startTime)*100/(this.endTime-this.startTime)
            let that = this
            let getTime = e
            for(var key in this.dataMapTime){
                if(that.carMap[key]){
                    console.log('继续')
                }else{
                    let isCode = this.dataMapTime[key].indexOf(getTime)
                    if(isCode >= 0){
                        let setData = this.dataMap[key][isCode]
                        let pngSrc = ''
                        if(setData.equipType == 101){
                            pngSrc = pavPng
                        }else if(setData.equipType == 201){
                            pngSrc = roll_d_Png
                        }else if(setData.equipType == 202){
                            pngSrc = roll_s_Png
                        }else if(setData.equipType == 203){
                            pngSrc = roll_t_Png
                        }
                        
                        fabric.Image.fromURL(pngSrc,function(oImage){
                            that.carMap[setData.equipCode] = oImage.set({
                                left:setData.coordinateX*code+that.pyXCode,
                                top:setData.coordinateY*code*-1+that.pyYCode,
                                originX: 'center',
                                originY: 'center',
                                angle: setData.angle*1,
                                class:'group',
                                selectable: false,
                                hasBorders: false,
                                hasControls: false,
                                id: 'group',
                                carName: ''
                            }).scale(0.16)
                            canvas.add(that.carMap[setData.equipCode])
                        })
                        let str1 = '名称:' + setData.equipName
                        let str2 = '编号:' + setData.equipCode
                        let eqCode1 = new fabric.Text(str1, {
                            fontSize: 12,
                            left: setData.coordinateX*code+that.pyXCode,
                            top: setData.coordinateY*code*-1+that.pyYCode-80,
                            originX: 'left',
                            originY: 'center',
                            id: 'groupText',
                            class:'groupText',
                            selectable: false,
                            hasBorders: false,
                            hasControls: false,
                        });
                        let eqCode2 = new fabric.Text(str2, {
                            fontSize: 12,
                            left: setData.coordinateX*code+that.pyXCode,
                            top: setData.coordinateY*code*-1+that.pyYCode-60,
                            originX: 'left',
                            originY: 'center',
                            id: 'groupText',
                            class:'groupText',
                            selectable: false,
                            hasBorders: false,
                            hasControls: false,
                        });
                        let groupList = [eqCode1,eqCode2]

                        that.carMapText[setData.equipCode] =  new fabric.Group(groupList,{
                            id: 'groupText',
                            class:'groupText',
                        })
                        canvas.add(that.carMapText[setData.equipCode])
                    }
                    return
                }
                let posiCode = this.dataMapTime[key].indexOf(getTime)
                if(posiCode >= 0){
                    let setData = this.dataMap[key][posiCode]
                    let setDataL = this.dataMap[key][posiCode-1]
                    // console.log(this.dataMap[key][posiCode])
                    this.toPlay(this.carMap[setData.equipCode],setData.coordinateX*code+this.pyXCode,setData.coordinateY*code*-1+this.pyYCode,setData.angle)
                    // this.toPlay(this.carMapText[setData.equipCode],setData.coordinateX*code+this.pyXCode,setData.coordinateY*code*-1+this.pyYCode-60,0)
                    
                    
                    
                    // 文字更新
                    let canvasArr = canvas.getObjects();
                    for (let i = 0; i < canvasArr.length; i++) {
                        if (canvasArr[i].id == "groupText"+setData.equipCode || canvasArr[i].id == "groupText") {
                            canvas.remove(canvasArr[i]);
                        }
                    }
                    let unit = setData.equipType == 101 ? 'm/min' : 'KM/H'
                    let str1 = '名称:' + setData.equipName
                    let str2 = '编号:' + setData.equipCode
                    let str3 = '速度:' + setData.speed + unit
                    let eqCode1 = new fabric.Text(str1, {
                        fontSize: 12,
                        left: setDataL.coordinateX*code+that.pyXCode,
                        top: setDataL.coordinateY*code*-1+that.pyYCode-80,
                        originX: 'left',
                        originY: 'center',
                        id: 'groupText'+setData.equipCode,
                        class:'groupText'+setData.equipCode,
                        selectable: false,
                        hasBorders: false,
                        hasControls: false,
                    });
                    let eqCode2 = new fabric.Text(str2, {
                        fontSize: 12,
                        left: setDataL.coordinateX*code+that.pyXCode,
                        top: setDataL.coordinateY*code*-1+that.pyYCode-60,
                        originX: 'left',
                        originY: 'center',
                        id: 'groupText'+setData.equipCode,
                        class:'groupText'+setData.equipCode,
                        selectable: false,
                        hasBorders: false,
                        hasControls: false,
                    });
                    let eqCode3 = new fabric.Text(str3, {
                        fontSize: 12,
                        left: setDataL.coordinateX*code+that.pyXCode,
                        top: setDataL.coordinateY*code*-1+that.pyYCode-40,
                        originX: 'left',
                        originY: 'center',
                        id: 'groupText'+setData.equipCode,
                        class:'groupText'+setData.equipCode,
                        selectable: false,
                        hasBorders: false,
                        hasControls: false,
                    });
                    // let groupList = [eqCode1,eqCode2,eqCode3]

                    // that.carMapText[setData.equipCode] =  new fabric.Group(groupList,{
                    //     id: 'groupText'+setData.equipCode,
                    //     class:'groupText'+setData.equipCode,
                    // })
                    canvas.add(eqCode1)
                    canvas.add(eqCode2)
                    canvas.add(eqCode3)
                    this.toPlay(eqCode1,setData.coordinateX*code+this.pyXCode,setData.coordinateY*code*-1+that.pyYCode-80,0.1)
                    this.toPlay(eqCode2,setData.coordinateX*code+this.pyXCode,setData.coordinateY*code*-1+that.pyYCode-60,0.1)
                    this.toPlay(eqCode3,setData.coordinateX*code+this.pyXCode,setData.coordinateY*code*-1+that.pyYCode-40,0.1)
                    
                    // console.log(that.carMapText[setData.equipCode])

                    
                    // if(setData.speed*1 <= 0){
                    //     return
                    // }
                    
                    // 填充颜色
                    let colorSet = ''
                    if(this.dimension == 1){
                        colorSet = '#32CD32'
                    }else if(this.dimension == 2){
                        colorSet = Math.ceil(this.dataMap[key][posiCode].rollingNum*1) < 20?this.rollNumColor[Math.ceil(this.dataMap[key][posiCode].rollingNum*1)]: this.rollNumColor[20]
                    }else if(this.dimension == 3){
                        if(this.dataMap[key][posiCode].icv < 64){
                            colorSet = this.icvColor['64']
                        }else if(this.dataMap[key][posiCode].icv < 74){
                            colorSet = this.icvColor['74']
                        }else if(this.dataMap[key][posiCode].icv < 84){
                            colorSet = this.icvColor['84']
                        }else if(this.dataMap[key][posiCode].icv < 94){
                            colorSet = this.icvColor['94']
                        }else{
                            colorSet = this.icvColor['100']
                        }
                    }
                    // console.log(this.dataMap[key][posiCode].equipType)
                    if(this.dataMap[key][posiCode].equipType == 101){
                        colorSet = '#696969'
                    }
                    // if(setDataL.coordinateX == '0.0' || setDataL.coordinateY == '0.0'){
                    //     return
                    // }
                    // if(setData.coordinateX == '0.0' || setData.coordinateY == '0.0'){
                    //     return
                    // }
                    this.contextM.lineWidth = 1
                    this.contextM.beginPath();
                    this.contextM.strokeStyle  = colorSet;
                    this.contextM.moveTo((setDataL.leftBoundaryMiddleCoordinateX*code+this.pyXCode)*this.imgScale + this.imgX,(setDataL.leftBoundaryMiddleCoordinateY*code*-1+this.pyYCode)*this.imgScale+this.imgY)
                    this.contextM.lineTo((setDataL.rightBoundaryMiddleCoordinateX*code+this.pyXCode)*this.imgScale + this.imgX,(setDataL.rightBoundaryMiddleCoordinateY*code*-1+this.pyYCode)*this.imgScale+this.imgY)
                    this.contextM.lineTo((setData.rightBoundaryMiddleCoordinateX*code+this.pyXCode)*this.imgScale + this.imgX,(setData.rightBoundaryMiddleCoordinateY*code*-1+this.pyYCode)*this.imgScale+this.imgY)
                    this.contextM.lineTo((setData.leftBoundaryMiddleCoordinateX*code+this.pyXCode)*this.imgScale + this.imgX,(setData.leftBoundaryMiddleCoordinateY*code*-1+this.pyYCode)*this.imgScale+this.imgY)
                    // this.contextM.closePath();
                    this.contextM.fillStyle = colorSet;
                    this.contextM.fill();
                    this.contextM.stroke();
                }
            }
        },
        initHistoryF: function(time){
            console.log('his')
            let st = this.startTime
            this.contextM.clearRect(0, 0, 1920, 1080);
            for(let i=st/1000+1;i<time/1000;i++){
                // console.log(i)
                let nt = i*1000
                for(var key in this.dataMapTime){
                    let posiCode = this.dataMapTime[key].indexOf(nt)
                    // console.log(posiCode)
                    // console.log(key)
                    if(posiCode > 0){
                        let jobType = this.dataMap[key][posiCode].jobType
                        let isGo = true
                        let getTime = time - nt
                        // console.log(getTime)
                        if(jobType == 4 && getTime > 600000){
                            isGo = false
                        }
                        if(jobType == 1 && getTime > 1200000){
                            isGo = false
                        }
                        if(isGo){
                            console.log('isGo')
                            let setData = this.dataMap[key][posiCode]
                            if(this.getCarList.indexOf(setData.equipCode) >= 0){
                                let setDataL = this.dataMap[key][posiCode-1]
                                // console.log(setData)
                                let colorSet = ''
                                if(this.dimension == 1){
                                    colorSet = '#32CD32'
                                }else if(this.dimension == 2){
                                    colorSet = Math.ceil(this.dataMap[key][posiCode].rollingNum*1) < 20?this.rollNumColor[Math.ceil(this.dataMap[key][posiCode].rollingNum*1)]: this.rollNumColor[20]
                                }else if(this.dimension == 3){
                                    if(this.dataMap[key][posiCode].compactionVal < 64){
                                        colorSet = this.icvColor['64']
                                    }else if(this.dataMap[key][posiCode].compactionVal < 74){
                                        colorSet = this.icvColor['74']
                                    }else if(this.dataMap[key][posiCode].compactionVal < 84){
                                        colorSet = this.icvColor['84']
                                    }else if(this.dataMap[key][posiCode].compactionVal < 94){
                                        colorSet = this.icvColor['94']
                                    }else{
                                        colorSet = this.icvColor['100']
                                    }
                                }
                                if(this.dataMap[key][posiCode].equipType == 101){
                                    colorSet = '#696969'
                                }
                                let getPosiNL = onePointerChange([setData.leftBoundaryMiddleCoordinateX,setData.leftBoundaryMiddleCoordinateY])
                                let getPosiNR = onePointerChange([setData.rightBoundaryMiddleCoordinateX,setData.rightBoundaryMiddleCoordinateY])
                                let getPosiLL = onePointerChange([setDataL.leftBoundaryMiddleCoordinateX,setDataL.leftBoundaryMiddleCoordinateY])
                                let getPosiLR = onePointerChange([setDataL.rightBoundaryMiddleCoordinateX,setDataL.rightBoundaryMiddleCoordinateY])
                                this.contextM.lineWidth = 1
                                this.contextM.beginPath();
                                this.contextM.strokeStyle  = colorSet;
                                console.log(this.imgX)
                                console.log(this.imgY)
                                this.contextM.moveTo(getPosiLL[0]*this.imgScale+this.imgX,getPosiLL[1]*this.imgScale+this.imgY)
                                this.contextM.lineTo(getPosiLR[0]*this.imgScale+this.imgX,getPosiLR[1]*this.imgScale+this.imgY)
                                this.contextM.lineTo(getPosiNR[0]*this.imgScale+this.imgX,getPosiNR[1]*this.imgScale+this.imgY)
                                this.contextM.lineTo(getPosiNL[0]*this.imgScale+this.imgX,getPosiNL[1]*this.imgScale+this.imgY)
                                this.contextM.fillStyle = colorSet;
                                this.contextM.fill();
                                this.contextM.stroke();
                            }
                            
                        }
                        
                        
                    }
                    
                }
            }
        },
        initHistory: function(time,code){
            console.log('his')
            let st = this.startTime
            // this.contextM.clearRect(0, 0, 1920, 1080);
            for(let i=st/1000+1;i<time/1000;i++){
                // console.log(i)
                let nt = i*1000
                for(var key in this.dataMapTime){
                    let posiCode = this.dataMapTime[key].indexOf(nt)
                    // console.log(posiCode)
                    // console.log(key)
                    if(posiCode > 0){
                        let jobType = this.dataMap[key][posiCode].jobType
                        let isGo = true
                        let getTime = time - nt
                        console.log(getTime)
                        if(jobType == 4 && getTime > 600000){
                            isGo = false
                        }
                        if(jobType == 1 && getTime > 1200000){
                            isGo = false
                        }
                        if(isGo){
                            let setData = this.dataMap[key][posiCode]
                            let setDataL = this.dataMap[key][posiCode-1]
                            // console.log(setData)
                            let colorSet = ''
                            if(this.dimension == 1){
                                colorSet = '#32CD32'
                            }else if(this.dimension == 2){
                                colorSet = Math.ceil(this.dataMap[key][posiCode].rollingNum*1) < 20?this.rollNumColor[Math.ceil(this.dataMap[key][posiCode].rollingNum*1)]: this.rollNumColor[20]
                            }else if(this.dimension == 3){
                                if(this.dataMap[key][posiCode].compactionVal < 64){
                                    colorSet = this.icvColor['64']
                                }else if(this.dataMap[key][posiCode].compactionVal < 74){
                                    colorSet = this.icvColor['74']
                                }else if(this.dataMap[key][posiCode].compactionVal < 84){
                                    colorSet = this.icvColor['84']
                                }else if(this.dataMap[key][posiCode].compactionVal < 94){
                                    colorSet = this.icvColor['94']
                                }else{
                                    colorSet = this.icvColor['100']
                                }
                            }
                            if(this.dataMap[key][posiCode].equipType == 101){
                                colorSet = '#696969'
                            }
                            
                            this.contextM.lineWidth = 1
                            this.contextM.beginPath();
                            this.contextM.strokeStyle  = colorSet;
                            this.contextM.moveTo((setDataL.leftBoundaryMiddleCoordinateX*code+this.pyXCode)*this.imgScale + this.imgX,(setDataL.leftBoundaryMiddleCoordinateY*code*-1+this.pyYCode)*this.imgScale+this.imgY)
                            this.contextM.lineTo((setDataL.rightBoundaryMiddleCoordinateX*code+this.pyXCode)*this.imgScale + this.imgX,(setDataL.rightBoundaryMiddleCoordinateY*code*-1+this.pyYCode)*this.imgScale+this.imgY)
                            this.contextM.lineTo((setData.rightBoundaryMiddleCoordinateX*code+this.pyXCode)*this.imgScale + this.imgX,(setData.rightBoundaryMiddleCoordinateY*code*-1+this.pyYCode)*this.imgScale+this.imgY)
                            this.contextM.lineTo((setData.leftBoundaryMiddleCoordinateX*code+this.pyXCode)*this.imgScale + this.imgX,(setData.leftBoundaryMiddleCoordinateY*code*-1+this.pyYCode)*this.imgScale+this.imgY)
                            // this.contextM.closePath();
                            this.contextM.fillStyle = colorSet;
                            this.contextM.fill();
                            this.contextM.stroke();
                        }
                        
                        
                    }
                    
                }
            }
        },
        getTimeInList : function(e){
            let arr = []
            for(let i=0;i<e.length;i++){
                arr.push(new Date(e[i].gpsTime).getTime())
            }
            console.log(arr)
            return arr
        },
        drawByPageZ:function(data){
            // console.log(data)
            if(data.pileNum){
                //获取桩号
                let getNum = (data.pileNum + '').split(".")
                let pileNum = ((getNum[0]*1)/1000 + '').split(".")
                let num = ''
                if(getNum.length == 1){
                    num = 'K'+pileNum[0]+'+'+pileNum[1]
                }else{
                    num = 'K'+pileNum[0]+'+'+pileNum[1]+'.'+(getNum[1]+'').substring(0,1)
                }
                // console.log(num)
                //获取偏移量
                let code = Math.floor(data.direction*1)
                var yAxisData = this.$store.state.roadWidth;
                if(code < 10){
                    if(this.xAxisValue.indexOf(num)>=0){
                        let setNum = (this.xAxisValue.indexOf(num)) * yAxisData.indexOf(code) + yAxisData.indexOf(code)
                        this.rollTimesList[setNum][2] = data.rolledPassNumber
                        this.rollIcvList[setNum][2] = data.icv
                    }
                }
            }
            this.rollCodeV = this.rollCodeV+1
            if(this.rollCodeV >= 100){
                let startT = this.rollTimesHeat.getOption().dataZoom[0].start
                let endT = this.rollTimesHeat.getOption().dataZoom[0].end
                let paramsT = paramsT
                this.paramsT.startT = startT
                this.paramsT.endT = endT

                let startI = this.rollIcvHeat.getOption().dataZoom[0].start
                let endI = this.rollIcvHeat.getOption().dataZoom[0].end
                let paramsI = paramsI
                this.paramsI.startI = startI
                this.paramsI.endI = endI
                const colorBox =  this.colorBox
                const colorBox1 =  this.colorBox1
                let chartOption = {
                    visualMap: {
                      type: "piecewise",
                      min: 0,
                      max: 10,
                      calculable: true,
                      realtime: false,
                      orient: "horizontal",
                      left: "center",
                      bottom: "15%",
                      show: false,
                      pieces: [
                        // { min: 20, max: 21 },
                        // { min: 0, max: 1 },
                        { min: 1, max: 1 },
                        { min: 2, max: 2 },
                        { min: 3, max: 3 },
                        { min: 4, max: 4 },
                        { min: 5, max: 5 },
                        { min: 6, max: 6 },
                        { min: 7, max: 7 },
                        { min: 8, max: 8 },
                        { min: 9, max: 9 },
                        { min: 10, max: 10 },
                        { min: 11, max: 11 },
                        { min: 12, max: 12 },
                        { min: 13, max: 13 },
                        { min: 14, max: 14 },
                        { min: 15, max: 15 },
                        { min: 16, max: 16 },
                        { min: 17, max: 17 },
                        { min: 18, max: 18 },
                        { min: 19, max: 19 },
                        { min: 20 },
                      ],
                      color: colorBox,
                    },
                    tooltip: {
                      position: "top",
                      formatter: function(a){
                        console.log(a)
                        let str = a.data[2]?a.data[2]:'暂无'
                       return a.name+':'+' '+ str;
                      }
                    },
                    animation: false,
                    grid: {
                      height: "70%",
                      top: "10%",
                    },
                    xAxis: {
                      type: "category",
                      data: this.xAxisValue,
                      splitArea: {
                        show: false,
                      },
                      splitLine:{
                        show:false
                      },
                      axisLabel:{
                        color: '#ffffff',
                        fontSize: 10,
                      },
                      axisLine:{
                        lineStyle:{
                          color:'#194793'
                        }
                      },
                      axisTick:{
                        show:false
                      }
                    },
                    yAxis: {
                      type: "category",
                      data: this.yData,
                      splitArea: {
                        show: false,
                      },
                      splitLine:{
                        show:true,
                        lineStyle:{
                          color: ['#194793']
                        }
                      },
                      axisLabel:{
                        color: '#ffffff',
                        fontSize: 10,
                      },
                      axisLine:{
                          show: false,
                          lineStyle:{
                            color:'#878787'
                          }
                        },
                      axisTick:{
                        show:false
                      }
                    },
                    series: [
                      {
                        // name: "Punch Card",
                        type: "heatmap",
                        data: this.rollTimesList,
                        label: {
                          show: false,
                        },
                        emphasis: {
                          itemStyle: {
                            shadowBlur: 10,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                          },
                        },
                      },
                    ],
                    dataZoom: [{
                        type: 'slider',
                        show: true,
                        realtime: true,
                        start: this.paramsT.startT,
                        end: this.paramsT.endT,
                        handleSize: '10%',
                        height: 10,
                        handleStyle:{
                          borderWidth: 2
                        },
                        bottom:'10%',
                        borderColor: '#0492FF',
                        fillerColor: '#265DFD',
                        textStyle:{
                          color: '#ffffff'
                        }
                    }, {
                        type: 'inside',
                        xAxisIndex: [0],
                    }, {
                        type: 'slider',
                        yAxisIndex: [0],
                        show: false,
                        zoomLock: true
                    }]
                };
                this.rollTimesHeat.setOption(chartOption);
                let chartOption1 = {
                visualMap: {
                    type: "piecewise",
                    min: 0,
                    max: 10,
                    calculable: true,
                    realtime: false,
                    orient: "horizontal",
                    left: "center",
                    bottom: "15%",
                    show: false,
                    pieces: [
                        { min: 1, max: 64 },
                        { min: 65, max: 74 },
                        { min: 75, max: 84 },
                        { min: 85, max: 94 },
                        { min: 95 },
                    ],
                    color: colorBox1,
                },
                tooltip: {
                    position: "top",
                    formatter: function(a){
                    console.log(a)
                    let str = a.data[2]?a.data[2]:'暂无'
                    return a.name+':'+' '+ str;
                    }
                },
                animation: false,
                grid: {
                    height: "70%",
                    top: "10%",
                },
                xAxis: {
                    type: "category",
                    data: this.xAxisValue,
                    splitArea: {
                    show: false,
                    },
                    splitLine:{
                    show:false
                    },
                    axisLabel:{
                    color: '#ffffff',
                    fontSize: 10,
                    },
                    axisLine:{
                    lineStyle:{
                        color:'#194793'
                    }
                    },
                    axisTick:{
                    show:false
                    }
                },
                yAxis: {
                    type: "category",
                    data: this.yData,
                    splitArea: {
                    show: false,
                    },
                    splitLine:{
                    show:true,
                    lineStyle:{
                        color: ['#194793']
                    }
                    },
                    axisLabel:{
                    color: '#ffffff',
                    fontSize: 10,
                    },
                    axisLine:{
                        show: false,
                        lineStyle:{
                        color:'#878787'
                        }
                    },
                    axisTick:{
                    show:false
                    }
                },
                series: [
                    {
                    // name: "Punch Card",
                    type: "heatmap",
                    data: this.rollIcvList,
                    label: {
                        show: false,
                    },
                    emphasis: {
                        itemStyle: {
                        shadowBlur: 10,
                        shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                    },
                ],
                dataZoom: [{
                    type: 'slider',
                    show: true,
                    realtime: true,
                    start: this.paramsI.startI,
                    end: this.paramsI.endI,
                    handleSize: '10%',
                    height: 10,
                    handleStyle:{
                        borderWidth: 2
                    },
                    bottom:'10%',
                    borderColor: '#0492FF',
                    fillerColor: '#265DFD',
                    textStyle:{
                        color: '#ffffff'
                    }
                }, {
                    type: 'inside',
                    xAxisIndex: [0],
                }, {
                    type: 'slider',
                    yAxisIndex: [0],
                    show: false,
                    zoomLock: true
                }]
                };
                this.rollIcvHeat.setOption(chartOption1);
                this.rollCodeV = 0
            }
            
        },
        drawNone: function(data){
            console.log(data,'out')
        },
        //canvas to img and clear canvas
        coverCanvasToImage: function(){
            let that = this
            this.midCanvas.setViewportTransform([1,0,0,1,0,0])
            this.canvas.setViewportTransform([1,0,0,1,0,0])
            setTimeout(function(){
                var image = new Image()
                let canvas = document.getElementById('midCanvas')
                image.src = canvas.toDataURL("image/png")
                that.midCanvas.clear()
                that.canvasNumClear = 0
                fabric.Image.fromURL(image.src,function(oImage){
                    let setImg = oImage.set({
                        left:0,
                        top:0,
                        selectable: false,
                        hasBorders: false,
                        hasControls: false,
                    })
                    that.midCanvas.add(setImg)
                })
            },100)
            
        },
        //五均分坐标
        fiveCoorSet: function(obj,arr,equipCode){
            let setArr = arr
            for(let i=0;i<setArr.length;i++){
                let coor = onePointerChange([setArr[i].x,setArr[i].y])
                obj[equipCode + i] = coor
            }
            // //console.log(obj)
        },
        // 绘制车辆行驶轨迹（轨迹维度）
        carTrajectory: function(){
            
        },
        carAlarm: function(equipCode,arr){
            if(JSON.stringify(this.alarmList[equipCode]) != JSON.stringify(arr)){
                //console.log('warnUndata')
                this.warnList = []
                this.alarmList[equipCode] = arr
                for(let key in this.alarmList){
                    let obj = {
                        equipName: this.carObj[key],
                        equipCode: key,
                        list: this.alarmList[key]
                    }
                    if(this.alarmList[key] != null){
                        this.warnList.push(obj)
                    }
                }
                this.warnNum = this.warnList.length
            }
            
        },
        carTopAlarm: function(equipCode,arr){
            if(JSON.stringify(this.topAlarmList[equipCode]) != JSON.stringify(arr)){
                //console.log('warnUndata')
                this.topWarnList = []
                this.topAlarmList[equipCode] = arr
                for(let key in this.topAlarmList){
                    let obj = {
                        equipName: this.carObj[key],
                        equipCode: key,

                        list: this.topAlarmList[key]
                    }
                    if(this.topAlarmList[key] != null){
                        this.topWarnList.push(obj)
                    }
                }
                if(this.topWarnList.length > 0){
                    this.$refs.warnNumContent.style.right = 360+'px'
                    this.$refs.warnContent.style.right = 0+'px'
                    this.warnShowCode = 1
                }
                console.log(this.topWarnList,'topWarnList')
                // this.warnNum = this.warnList.length
            }
            
            
        },
        // 车辆文字信息展示
        carInfoShow: function(x,y,equipCode,setArr,type){
            let canvasArr = this.canvas.getObjects()
            for(let i=0;i<canvasArr.length;i++){
                if(canvasArr[i].id == "groupCarInfo"+equipCode){
                    this.canvas.remove(canvasArr[i])
                }
            }
            let yDev = 0 //top方向偏移
            if(setArr.length == 0){
                yDev = 35
            }else if(setArr.length <= 2){
                yDev = 51
            }else if(setArr.length <= 4){
                yDev = 67
            }else{
                yDev = 83
            }
            let groupList = []
            
            //边框
            
            let contentArr = [[x,y],[x+163,y],[x+163,y+yDev],[x,y+yDev],[x,y+yDev-10],[x-7,y+yDev-18],[x,y+yDev-26]]
            let pathV = setPathValue(contentArr)
            this.infoAll[equipCode] = new fabric.Path(pathV)
            this.infoAll[equipCode].set({fill:'rgba(255,255,255,0.3)'})
            groupList.push(this.infoAll[equipCode])
            //标题
            this.titleShow[equipCode] = new fabric.Text(this.getData.equipName)
            this.titleShow[equipCode].set({
                fontSize: 14,
                left: x+12,
                top: y+9,
                fill: '#282828',
                fontWeight: '600'
            })
            groupList.push(this.titleShow[equipCode])
            //具体内容
            let leftCode = ''
            let topCode = ''
            for(let i=0;i<setArr.length;i++){
                if(i%2 == 0){
                    leftCode = x + 22
                    topCode = y+32+i*8
                }else{
                    leftCode = x + 103
                    topCode = y+32+(i-1)*8
                }
                let dw = ''
                switch (setArr[i]){
                    case 'icv':
                        break
                    case 'speed':
                        if(type < 200){
                            dw = 'm/min'
                        }else{
                            dw = 'Km/h'
                        }
                        break
                    case 'temperature':
                        dw = '℃'
                        break
                    case 'oilmass':
                        if(type < 200){
                            dw = 'L'
                        }else{
                            dw = '%'
                        }
                        break
                    case 'frequencyVal':
                        dw = 'Hz'
                        break
                    case 'swingVal':
                        dw = 'mm'
                        break
                }
                this.getData[setArr[i]] = this.getData[setArr[i]]?this.getData[setArr[i]]:'--'
                this.infoItem[equipCode] = new fabric.Text(this.getData[setArr[i]]+dw)
                this.infoItem[equipCode].set({
                    fontSize: 14,
                    left: leftCode,
                    top: topCode,
                    fill: '#282828'
                })
                this.infoItemPointer[equipCode] = new fabric.Circle({
                    radius: 2,
                    fill: '#E24747',
                    left: leftCode - 8,
                    top: topCode + 7,
                    originX: 'center',
                    originY: 'center'
                })
                groupList.push(this.infoItem[equipCode])
                groupList.push(this.infoItemPointer[equipCode])
            }
            this.group[equipCode] = new fabric.Group(groupList)
            this.group[equipCode].set({
                class:'groupCar groupCarInfo'+equipCode,
                selectable: false,
                hasBorders: false,
                hasControls: false,
                id: 'groupCarInfo'+equipCode
            }).scale(0.2*(0.24/this.scaleCode))
            this.canvas.add(this.group[equipCode])
        },
        // 车辆运行动画函数
        toPlay: function(obj,toX,toY,toAngle){
            if(obj){
                obj.animate('top',toY,{
                    duration: 1000,
                    // onChange: this.canvas.renderAll.bind(this.canvas)
                })
                obj.animate('left',toX,{
                    duration: 1000,
                    // onChange: this.canvas.renderAll.bind(this.canvas)
                })
                obj.animate('angle',toAngle,{
                    duration:1000,
                    onChange: this.canvas.renderAll.bind(this.canvas)
                })
                
                // objT.animate('top',toY-50,{
                //     duration: 600,
                //     // onChange: this.canvas.renderAll.bind(this.canvas)
                // })
                // objT.animate('left',toX+35,{
                //     duration: 600,
                //     onChange: this.canvas.renderAll.bind(this.canvas)
                // })
            }
            
        }

    }
  };